import type {PageRouteConfig} from '@router';

import CpcPaymentSuccess from 'modules/Cpc/PaymentSuccess/CpcPaymentSuccess';

export function createCpcPaymentSuccessRoute(): PageRouteConfig {
  return {
    element: <CpcPaymentSuccess />,
    layout: {
      title: 'کلیک',
      hasNavigate: false,
      hasHeader: false,
      hasBack: true,
      hasLeftIcon: false
    }
  };
}
